// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__ICNHI","contactus":"Contact_contactus__L498k","details":"Contact_details__zjUHQ","form":"Contact_form__yHAFa"};